module.exports = __webpack_public_path__ + "assets/img/29_206.5f85c77e.jpg";